import Vue from 'vue'

import Tabs from '@/components/page/Tabs'
Vue.component('Tabs', Tabs)
import CustomFilter from '@/components/page/CustomFilter'
Vue.component('CustomFilter', CustomFilter)
import MainTable from '@/components/page/MainTable'
Vue.component('MainTable', MainTable)
import TableCell from '@/components/page/TableCell'
Vue.component('TableCell', TableCell)
import CustomDialog from '@/components/CustomDialog'
Vue.component('CustomDialog', CustomDialog)
import DateRange from '@/components/DateRange'
Vue.component('DateRange', DateRange)
import Uploader from '@/components/Uploader'
Vue.component('Uploader', Uploader)




// WEBPACK FOOTER //
// ./src/custom-components.js